import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'

import styles from './Content.module.scss'

export const Content = ({ questions }) => {
  const total = R.length(questions)

  return (
    <Box className={styles.content} tagName="article">
      <List direction="column">
        {R.addIndex(R.map)(({ description, id, title }, index) => {
          const count = index + 1

          return (
            <List.Item key={id}>
              <span className={styles.count}>{t`${count} of ${total}`}</span>
              <h3 className={styles.title}>{title}</h3>
              {R.gt(R.length(description), 0) ? (
                <Box className={styles.container} direction="column">
                  <p className={styles.description}>{description}</p>
                </Box>
              ) : null}
            </List.Item>
          )
        }, questions)}
      </List>
    </Box>
  )
}
